import { actions } from "../../actions/jobs/jobs";

export default function jobs( state, action ) {

    if( !state ) {
        return {
            applications: { internal: [], external: [] },
            jobs: [],
            favouriteJobs: [],
        };
    }

    const newState = { ...state };

    switch( action.type ) {
        case actions.SET_CURRENT_JOB: return setCurrentJob( newState, action.job );
        case actions.RESET_CURRENT_JOB: return resetCurrentJob( newState, action );
        case actions.GET_JOBS: return getJobs( newState );
        case actions.SET_JOBS: return setJobs( newState, action );
        case actions.CLEAR_JOBS: return clearJobs( newState, action );
        case actions.GET_MY_JOBS: return getMyJobs( newState );
        case actions.SET_MY_JOBS: return setMyJobs( newState, action );
        case actions.GET_MY_JOB_APPLICATIONS: return getMyJobApplications( newState );
        case actions.SET_MY_JOB_APPLICATIONS: return setMyJobApplications( newState, action );
        // case actions.SET_FAVOURITE_JOBS: return setFavouriteJobs( newState, action );
        case actions.SET_FAVOURITE_JOBS: return setJobs( newState, action );
        case actions.ADD_JOB_TO_FAVOURITES: return addJobToFavourites( newState, action );
        case actions.REMOVE_JOB_FROM_FAVOURITES: return removeJobFromFavourites( newState, action );
        case actions.SET_PREMIUM_JOBS: return setPremiumJobs( newState, action.premium_jobs );
        case actions.SET_SEARCH: return setJobSearch( newState, action );
        case actions.RESET_SEARCH_INITIAL_VALUES: return resetJobSearchInitialValues( newState );
        case actions.SET_HOME_TILE_JOBS: return setHomeTileJobs( newState, action.jobs_homepage );
        case actions.SET_APPLICATION_STATUSES: return setStatus( newState, action );
        // case actions.UPDATE_APPLICATION_STATUS: return setStatus( newState, action );
        case actions.SET_ALL_SAVED_SEARCHES: return setAllSavedSearches( newState, action );
        case actions.SAVE_SEARCH: return saveSearch( newState, action );
        case actions.DELETE_SAVED_SEARCH: return deleteSavedSearch( newState, action );
        case actions.SET_JOBS_INITIAL_VALUES: return setJobsInitialValues( newState, action );
        case actions.SET_JOB_ALERT: return setJobAlert( newState, action );
        case actions.GET_ALL_SAVED_SEARCHES: return getAllSavedSearches( newState, action);
        default: return state;
    }
}

function saveSearch( newState, action ) {

    newState.saveSuccessful = action.saveSuccessful;

    return newState;
}

function setCurrentJob( newState, job ) {
    newState.current_job = job;
    return newState;
}

function resetCurrentJob( newState, action ) {

    const copy = {...newState};
    copy.current_job = {};
    newState = copy;

    return newState;
}

function setStatus( newState, action ) {
    newState.statuses = action.status;
	return newState;
}

function setJobAlert( newState, action ) {

    const savedSearches = [ ...newState.savedSearches ];

    const flag = action.flag === 'set' ? 1 : 0;

    savedSearches[ action.index ].alert = flag;

    newState.savedSearches = savedSearches;

    return newState;
}

function setJobsInitialValues( newState, action ) {
    newState.options = action.options;
    return newState;
}

function getJobs( newState ) {
    newState.jobs = 'load';
    newState.pagination = '';
    // newState.options = '';
    return newState;
}

function setJobs( newState, action ) {
    newState.jobs = action.jobs;
    newState.pagination = action.pagination;
    newState.options = action.options;
    return newState;
}

function clearJobs(newState, action) {
    newState.jobs = 'load';
    return newState;
}

// {page: 1, country_id: {…}, region_id: Array(1)}
// country_id: {value: 77, label: "United Kingdom"}
// page: 1
// region_id: Array(1)
// 0: {value: 4, label: "East of England"}

function getMyJobApplications( newState ) {

    newState.applications = { internal: [], external: [] };
    newState.pagination = '';
    newState.options = '';

    return newState;
}



function getMyJobs( newState ) {
    newState.myJobs = 'loading';
    return newState;
}

function setMyJobs( newState, action ) {

    const pagination = {current_page: action.myJobs.current_page, total_pages: action.myJobs.total, total_rows: action};

    newState.myJobs = action.myJobs;
    newState.pagination = pagination;
    return newState;
}


function setMyJobApplications( newState, action ) {
	const _applications = {...newState.applications};

	const internal = [];
	const external = [];

	action.myApplications.forEach((application) => {

		if (application.external && !application.job_application.complete) {
			external.push(application);
		} else {
			internal.push(application);
		}

	});

	_applications.external = external;
	_applications.internal = internal;

	newState.applications = _applications;

	newState.pagination = action.pagination;

	delete action.options.job_id;

	newState.options = action.options;

  return newState;
}

function addJobToFavourites( newState, action ) {
    const jobs = newState.jobs.length > 0 ? JSON.parse(JSON.stringify( newState.jobs.length > 0 ? newState.jobs : newState.myJobs )) : [];

    if( !action.skip ){
        const favouriteJob = jobs.filter( job => job.id === action.jobId )[ 0 ];
        favouriteJob.favourite = 1;
    };

    newState.jobs.length > 0 ? newState.jobs = jobs : newState.myJobs = jobs;

    if( newState.current_job && Object.keys(newState.current_job).length ){
        newState.current_job = { ...newState.current_job, favourite : 1 };
    };

    return newState;

}

function removeJobFromFavourites( newState, action ) {
    const jobs = newState.jobs.length > 0 ? JSON.parse(JSON.stringify( newState.jobs.length > 0 ? newState.jobs : newState.myJobs )) : [];

    if( !action.skip ){
        const favouriteJob = jobs.filter( job => job.id === action.jobId )[ 0 ];
        favouriteJob.favourite = 0;
    };

    newState.jobs.length > 0 ? newState.jobs = jobs : newState.myJobs = jobs;

    if( newState.current_job && Object.keys(newState.current_job).length ){
        newState.current_job = { ...newState.current_job, favourite : 0 };
    };

    return newState;

}


function setFavouriteJobs( newState, action ) {


    newState.favouriteJobs = action.favouriteJobs;
    newState.pagination = action.pagination;
    newState.options = action.options;


    return newState;
}

function resetJobSearchInitialValues( newState ) {
    newState.options = '';

    return newState;
}

function setJobSearch( newState, action ) {
    newState.jobs = action.jobs;
    newState.pagination = action.pagination;

    return newState;
}

function setPremiumJobs( newState, premium ) {
    newState.premium = premium;

    return newState;
}

function setHomeTileJobs( newState, jobs ) {
    newState.jobs_homepage = jobs;

    return newState;
}

function getAllSavedSearches( newState, action) {
  newState.isFetching = action.isFetching;

  return newState;
}

function setAllSavedSearches( newState, action) {
    newState.savedSearches = action.savedSearches;

    newState.pagination = action.pagination;
    newState.options = action.options;
    newState.isFetching = action.isFetching;

    return newState;
}

function deleteSavedSearch(newState, action) {
    newState.savedSearches = newState.savedSearches.filter((search) => search.id !== action.removedSearchId);
    return newState;
}



// WEBPACK FOOTER //
// src/client/reducers/jobs/jobs.js